import { render, staticRenderFns } from "./AwardForm.vue?vue&type=template&id=3363ecba&"
import script from "./AwardForm.vue?vue&type=script&lang=js&"
export * from "./AwardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports